var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11.259,
  height: 11.448,
  viewBox: "0 0 11.259 11.448"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3617",
  "data-name": "Group 3617",
  transform: "translate(-961.362 -333.152)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M-4594.261-691.587h-1.944v10h10V-683.4",
  transform: "translate(5558.167 1025.587)",
  fill: "none",
  stroke: "#1370fc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3178",
  "data-name": "Group 3178",
  transform: "translate(965.64 334)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M-4590.015-685.789l6.133-6.2",
  transform: "translate(4590.015 691.988)",
  fill: "none",
  stroke: "#1370fc",
  strokeLinecap: "round",
  strokeWidth: 1.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M-4587.394-691.587h4.074v3.886",
  transform: "translate(4589.643 691.587)",
  fill: "none",
  stroke: "#1370fc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
})))));
export default __webpack_public_path__ + "static/media/link.f794fc43.svg";
export { SvgComponent as ReactComponent };